module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r7r2r5r-2bf5c02ff8906d71e386b5b6bb8abac5.svg";